<div>
    @if (dataLoaded && data?.components?.length > 0 && !showSpinner) {
    <div class="p-24 mt-24">
        <div class="flex flex-row justify-between product-header pt-6 pr-30 pb-6 pl-32 bg-color fw-600">
            <div>{{'INSTANCE_DETAILS.COMPONENT' | transloco }}</div>
            <div>{{'INSTANCE_DETAILS.CURRENT_VERSION' | transloco }}</div>
        </div>
        <div *ngFor="let element of data?.components | keyvalue"
            class="flex flex-row justify-between product-rows pt-6 pr-30 pb-6 pl-32 mt-8 mb-8">
            <div>{{element.key}}</div>
            <div>{{element.value}}</div>
        </div>
    </div>
    } @else {
    @if ( showSpinner) {
    <mat-card class="flex spinner-container spinner mt-60">
        <mat-spinner diameter="24" color="primary" mode="indeterminate">
        </mat-spinner>
    </mat-card>
    } @else {
    <div class="no-data flex flex-col items-center justify-center pt-8 pb-8 mt-150">
        <img src="/assets/images/no-data.png">
        <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
    </div>
    }
    }
</div>